var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupplyChainTab = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/supply chain"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1269",
    d: "M8.33984 2.55762H10.2698C10.5735 2.55762 10.8546 2.71837 11.0086 2.98017L12.9246 6.23732C13.0823 6.50557 13.0823 6.83826 12.9246 7.1065L11.0086 10.3637C10.8546 10.6255 10.5735 10.7862 10.2698 10.7862H8.33984",
    stroke: "#0C193B",
    strokeWidth: 0.857145,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1270",
    d: "M13.1797 2.55762H15.1096C15.4134 2.55762 15.6944 2.71837 15.8484 2.98017L17.7644 6.23732C17.9222 6.50557 17.9222 6.83826 17.7644 7.1065L15.8484 10.3637C15.6944 10.6255 15.4134 10.7862 15.1096 10.7862H13.1797",
    stroke: "#0C193B",
    strokeWidth: 0.857145,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1268",
    d: "M1.07812 3.41476C1.07812 2.94137 1.46188 2.55762 1.93527 2.55762H5.42823C5.73197 2.55762 6.01303 2.71837 6.16703 2.98017L8.08301 6.23732C8.2408 6.50557 8.2408 6.83826 8.08301 7.1065L6.16703 10.3637C6.01303 10.6255 5.73197 10.7862 5.42823 10.7862H1.93527C1.46188 10.7862 1.07812 10.4025 1.07812 9.92906V3.41476Z",
    stroke: "#0C193B",
    strokeWidth: 0.857145
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupplyChainTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/supply-chain-tab.87d7873322df8bfc77696f7de910f676.svg";